(function() {
'use strict';

angular
    .module('dashboard')
    .controller('ResendVoucher', ResendVoucher);

function ResendVoucher(dashboardBookingService, $routeParams, $rootScope, resourceService) {
    const cm = this;
    const bookingId = $routeParams.bookingId;

    cm.sendConfirmationEmail = sendConfirmationEmail;

    const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    dashboardBookingService.getContact(bookingId).then(function(contactDetail) {
        cm.Emails = contactDetail.data.Email;
    });

    dashboardBookingService.getBookingInfo(bookingId).then(function(booking) {
        cm.bk = booking;
    });

    function sendConfirmationEmail() {
        const emailsArray = cm.Emails.split(',');
        for (let i = emailsArray.length - 1; i >= 0; i--) {
            const email = emailsArray[i].trim();
            if (!validEmail.test(email)) {
                $rootScope.$broadcast('flash:error', String.format(resourceService.get('VOUCHERINVALID'), email));
                return;
            }
        }


        dashboardBookingService.sendConfirmationEmail(emailsArray, bookingId).then(function() {
            //$rootScope.$broadcast('flash:success', resourceService.get('VOUCHERSENT'));
            cm.isEmailSent = true;
        }, function() {
            $rootScope.$broadcast('flash:error', resourceService.get('VOUCHERSENTERROR'));
        });
    }
}
})();
